// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
// Common container imports
const socialMediums = require('./mediums')
// Sibling imports
const shareModalActions = require('./actions')
const ShareModal = require('./component-dumb')
const shareModalSelectors = require('./selectors')

function mapStateToProps() {
  const modelSelector = shareModalSelectors.createModelSelector()
  return function (state) {
    return {
      model: modelSelector(state),
      socialMediums
    }
  }
}

const mapDispatchToProps = {
  onCopy: shareModalActions.copy,
  onDismiss: shareModalActions.hide,
  onShare: shareModalActions.share
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    ShareModal
  )
)
